import { Grid } from '@material-ui/core';
import {
  createSelectField,
  createTextField,
} from '@roc/ui/componentBuilder';
import { observer } from 'mobx-react-lite';
import { createClosingConditionsLevelOptions } from '@roc/feature-utils';
import { CreatePostClosingConditionStore } from 'libs/feature-documents/src/documents/stores/documentForms/postClosingCondition/createPostClosingConditionStore';

interface CreatePostClosingConditionProps {
  store: CreatePostClosingConditionStore;
}

const CreatePostClosingCondition = observer((props: CreatePostClosingConditionProps) => {
  const { store } = props;
  const fields = store.form.fields;
  return (
    <Grid container spacing={3} style={{ width: '100%' }}>
      <Grid item xs={12}>
        {createSelectField({
          store,
          testId: 'level',
          fieldName: 'level',
          label: 'Post-Closing Condition Level',
          options: createClosingConditionsLevelOptions,
          disabled: false,
        })}
      </Grid>
      <Grid item xs={12}>
        {createTextField({
          store,
          testId: 'description',
          fieldName: 'description',
          label: 'Post-Closing Condition Description',
          multiline: true,
          minRows: 10,
          disabled: false,
        })}
      </Grid>
    </Grid>
  );
});

export default CreatePostClosingCondition;
